import { PLATFORMS } from 'src/tpbp-core/models/common.const'

const DevelopmentOnlyFeatureFlagIds = {
  debug: 'debug',
  debugTime: 'debugTime',
  inHurry: 'inHurry',
} as const

export const FEATURE_IDS = {
  ...DevelopmentOnlyFeatureFlagIds,
  activateSelfCareV2DMPCircuit: 'activateSelfCareV2DMPCircuit',
  activateSelfCareV2ProtectionCircuit: 'activateSelfCareV2ProtectionCircuit',
  activateSelfCareV2RetirementCircuit: 'activateSelfCareV2RetirementCircuit',
  activateSelfCareV2TaxationCircuit: 'activateSelfCareV2TaxationCircuit',
  activateSelfCareV2TransmissionCircuit:
    'activateSelfCareV2TransmissionCircuit',
  advisingReportMandateManagement: 'advisingReportMandateManagement',
  advisingReportMvp4: 'advisingReportMvp4',
  advisingReport_TF3130: 'advisingReport_TF3130',
  allocNewControl: 'allocNewControl',
  apiAgenda: 'apiAgenda',
  autoZoom: 'autoZoom',
  bareResultOnly: 'bareResultOnly',
  blockAccessToCircuitsForSelfcare: 'blockAccessToCircuitsForSelfcare',
  canSkipFastKyc: 'canSkipFastKyc',
  coupleApproach: 'coupleApproach',
  dmpEsg: 'dmpEsg',
  dmpGainLoss: 'dmpGainLoss',
  dmpMoreActions: 'dmpMoreActions',
  isDesignSystemEnabled: 'isDesignSystemEnabled',
  esg: 'esg',
  esgQuiz: 'esgQuiz',
  evolMvp2: 'evolMvp2',
  evolMvp3: 'evolMvp3',
  evolMvp4: 'evolMvp4',
  filterProducts: 'filterProducts',
  flatFastKYC: 'flatFastKYC',
  loiPacte: 'loiPacte',
  messageFees: 'messageFees',
  newReport: 'newReport',
  newReportHideFooter: 'newReportHideFooter',
  notMockAppointment: 'notMockAppointment',
  ownershipV2: 'ownershipV2',
  patrimonySelectionDeactivation: 'patrimonySelectionDeactivation',
  pedagogicalContents: 'pedagogicalContents',
  perActions: 'perActions',
  piQCEQuiz: 'piQCEQuiz',
  pivotAccountFundingEnhanced: 'pivotAccountFundingEnhanced',
  protectionCircuit: 'protectionCircuit',
  protectionCoupleMode: 'protectionCoupleMode',
  protectionDemo: 'protectionDemo',
  protectionPedagogicalContents: 'protectionPedagogicalContents',
  realEstateEstimation: 'realEstateEstimation',
  reallocation: 'reallocation',
  retirement: 'retirement',
  riskProjection: 'riskProjection',
  shortCircuit: 'shortCircuit',
  shouldDisplaySelfCareV2: 'shouldDisplaySelfCareV2',
  showContractDetailsInSidebar: 'showContractDetailsInSidebar',
  showMonthlyBuyoutInitial: 'showMonthlyBuyoutInitial',
  situationWidgetNew: 'situationWidgetNew',
  subscriptionLinks: 'subscriptionLinks',
  taxation: 'taxation',
  taxationCircuit: 'taxationCircuit',
  transmissionCircuit: 'transmissionCircuit',
  transmissionCircuitLot2: 'transmissionCircuitLot2',
  usePortfolioMeta: 'usePortfolioMeta',
  useSuitabilityReport: 'useSuitabilityReport',
  indicatorsOptimisation: 'indicatorsOptimisation',
} as const

export type FeatureId = ValueOf<typeof FEATURE_IDS>

export type FeatureFlagsForTesting<T extends FeatureId> = Pick<
  Record<FeatureId, boolean>,
  T
>

export const PLATFORMS_WITH_LOCALSTORAGE = [
  PLATFORMS.dev,
  PLATFORMS.homologation,
  PLATFORMS.release,
  PLATFORMS.unitTest,
]
